import "./style.css";

export const HeaderLogo = () => (
  <button type="button" className="logo" data-home-trigger aria-label="Return to home view">
    <img src="/images/ik-logo-lg.png" alt="IK Logo" className="logo__icon" />
    <span className="logo__text">IGOR KANIEWSKI</span>
  </button>
);
